export enum ProfilsDroitsPath {
  ROOT = '',
  CREATION = 'creation-profil',
  EDITION = 'edition-profil',
  COPIE = 'copie',
  ID_PROFIL_PARAM = 'idProfil',
}
